// CSV パーサ＋文字コード復号（中身/TMS）。ブラウザ・Node 双方で動く純関数。
// 出所: 配車担当日計表・トランコム取引状況・ハコベル案件CSV の取込用。外部ライブラリ非依存。

// バイト列 → 文字列。UTF-8(BOM)優先、ダメなら Shift_JIS(cp932) にフォールバック。
// vendor 設定で encoding を明示できる（'utf-8' | 'shift_jis' | 'auto'）。
export function decodeBytes(buf, encoding = 'auto') {
  const bytes = buf instanceof Uint8Array ? buf : new Uint8Array(buf)
  const stripBom = (s) => (s.charCodeAt(0) === 0xfeff ? s.slice(1) : s)
  if (encoding === 'shift_jis' || encoding === 'cp932') {
    return stripBom(new TextDecoder('shift_jis').decode(bytes))
  }
  if (encoding === 'utf-8' || encoding === 'utf8') {
    return stripBom(new TextDecoder('utf-8').decode(bytes))
  }
  // auto: UTF-8 を厳格判定し、壊れたら Shift_JIS
  try {
    const s = new TextDecoder('utf-8', { fatal: true }).decode(bytes)
    return stripBom(s)
  } catch {
    return stripBom(new TextDecoder('shift_jis').decode(bytes))
  }
}

// RFC4180 準拠のCSV分割。引用符内のカンマ・改行・二重引用符に対応。CRLF/LF 両対応。
export function parseCsv(text) {
  const rows = []
  let row = []
  let field = ''
  let inQuotes = false
  let i = 0
  const n = text.length
  const pushField = () => { row.push(field); field = '' }
  const pushRow = () => { rows.push(row); row = [] }
  while (i < n) {
    const c = text[i]
    if (inQuotes) {
      if (c === '"') {
        if (text[i + 1] === '"') { field += '"'; i += 2; continue }
        inQuotes = false; i++; continue
      }
      field += c; i++; continue
    }
    if (c === '"') { inQuotes = true; i++; continue }
    if (c === ',') { pushField(); i++; continue }
    if (c === '\r') { i++; continue }
    if (c === '\n') { pushField(); pushRow(); i++; continue }
    field += c; i++
  }
  // 末尾フィールド/行の取りこぼしを回収
  if (field.length > 0 || row.length > 0) { pushField(); pushRow() }
  // 完全な空行（末尾の空改行由来）は落とす
  return rows.filter((r) => !(r.length === 1 && r[0] === ''))
}

// テキスト → { headers, records }。records[k] はヘッダ名→値のオブジェクト＋生配列 __cells。
// 同名ヘッダは最初の出現を優先（ハコベルの重複的な列名対策）。
export function readTable(text) {
  const matrix = parseCsv(text)
  if (matrix.length === 0) return { headers: [], records: [] }
  const headers = matrix[0].map((h) => (h == null ? '' : String(h).trim()))
  const index = {}
  headers.forEach((h, i) => { if (h && !(h in index)) index[h] = i })
  const records = matrix.slice(1).map((cells, r) => {
    const obj = { __row: r + 2, __cells: cells }
    for (const h in index) obj[h] = cells[index[h]] ?? ''
    return obj
  })
  return { headers, index, records }
}
